import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";

function NewProjects() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "rgb(80, 165, 241)",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    minWidth: "11em",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [pmeData, setPmeData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const yesNoData = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const [selectedYesNo, setSelectedYesNo] = useState("");
  const renderYesNoOptions = () => {
    return [
      <option key="" value=""></option>,
      ...yesNoData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleYesNoChange = (e) => {
    setSelectedYesNo(e.target.value);
  };
  /*************************   publipostage *******************************/
  const [publipostageData, setPublipostageData] = useState({ data: [] });
  const [selectedPublipostage, setSelectedPublipostage] = useState("");
  const handlePublipostageChange = (e) => {
    setSelectedPublipostage(e);
  };
  const getPublipostage = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/publipostages`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPublipostageData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPublipostageOptions = () => {
    return [
      {
        options: publipostageData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  /*************************   Partenaire   *******************************/
  const [selectedPartenaire, setSelectedPartenaire] = useState("");
  const [partenaireData, setPartenaireData] = useState({ data: [] });
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((partenaire) => {
          setPartenaireData(partenaire);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: partenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const renderPartenaireHmfOptions = () => {
    return [
      <option key="" value=""></option>,
      ...partenaireData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  /************************* Nature investissement *******************************/
  const [secteurActiviteData, setSecteurActiviteData] = useState({
    data: [],
  });
  const [selectedSecteurActivite, setSelectedSecteurActivite] = useState("");
  const handleSecteurActiviteChange = (e) => {
    setSelectedSecteurActivite(e);
  };
  const getSecteurActivite = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/secteurs_activites`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSecteurActiviteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderSecteurActiviteOptions = () => {
    return [
      {
        options: secteurActiviteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };
  /*************************   END  *******************************/
  /*************************   Codes investissement *******************************/
  const [codesInvestissementData, setCodesInvestissementData] = useState({
    data: [],
  });
  const [selectedCodesInvestissement, setSelectedCodesInvestissement] =
    useState("");
  const handleCodesInvestissementChange = (e) => {
    setSelectedCodesInvestissement(e);
  };
  const getCodesInvestissement = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/codes_investissements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCodesInvestissementData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCodesInvestissementOptions = () => {
    return [
      {
        options: codesInvestissementData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };
  /*************************   END  *******************************/
  /*************************   DirectionProduits  *******************************/
  const [produitsData, setproduitsData] = useState({ data: [] });
  const [selectedDirectionProduit, setSelectedDirectionProduit] = useState("");
  const handleDirectionProduitChange = (e) => {
    setSelectedDirectionProduit(e);
  };
  const getDirectionProduit = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setproduitsData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderDirectionProduitOptions = () => {
    return [
      {
        options: produitsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };

  /*************************   END produits *******************************/
  /*************************   Exploitant   *******************************/
  const [ExploitantData, setExploitantData] = useState({ data: [] });

  const getExploitantData = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/partenaires2`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setExploitantData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderExploitantOptions = () => {
    return [
      {
        options: ExploitantData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };
  /************************* STATUT projets  *******************************/
  const [selectedStatutProjet, setSelectedStatutProjet] = useState("");
  const [statutData, setStatutProjetData] = useState({ data: [] });
  const handleStatutProjetChange = (e) => {
    setSelectedStatutProjet(e);
  };

  const getStatutProjet = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/statuts_projets`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setStatutProjetData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutProjetOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };
  /*************************   END STATUT *******************************/
  /*************************   SOCIETE  *******************************/
  const [societe, setClasseImmoData] = useState({ data: [] });
  const [selectedClasseImmo, setSelectedClasseImmo] = useState("");
  const handleClasseImmoChange = (e) => {
    setSelectedClasseImmo(e);
  };
  const getClasseImmo = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/classes_immobilisations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setClasseImmoData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderClasseImmoOptions = () => {
    return [
      {
        options: societe.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };

  /*************************   END SOCIETE *******************************/
  /********************services_impots_entreprises */
  const [selectedService, setSelectedService] = useState("");
  const [serviceData, setServiceData] = useState({ data: [] });
  const handleServiceChange = (e) => {
    setSelectedService(e);
  };
  const getService = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/projets/services_impots_entreprises`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((service) => {
          setServiceData(service);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderServiceOptions = () => {
    return [
      {
        options: serviceData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   Investissement   *******************************/
  const [selectedInvestissement, setSelectedInvestissement] = useState("");
  const [investData, setInvestissementData] = useState({ data: [] });
  const handleInvestissementChange = (e) => {
    setSelectedInvestissement(e);
  };
  // Fonction modifiée pour récupérer les investissements par PME
  const getInvestissementByPmeId = async (pmeId, rowIndex) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/projets/investissements?pme_id=${pmeId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      console.log(typeof data);
      // Mettre à jour le state avec les investissements pour cette ligne spécifique
      setFormInvestissement((prevState) =>
        prevState.map((row) => {
          if (row.index === rowIndex) {
            return {
              ...row,
              availableInvestissements: data, // Stocker les investissements disponibles pour cette ligne
            };
          }
          return row;
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  const renderInvestissementOptions = (rowData) => {
    // Si aucun PME n'est sélectionné ou si rowData n'est pas défini
    if (!rowData || !rowData.pme_id) {
      return <option value="">Sélectionnez d'abord une PME</option>;
    }
    if (rowData.pme_id && !rowData.availableInvestissements) {
      getInvestissementByPmeId(rowData.pme_id, rowData.index);
    }
    // Vérifier si availableInvestissements existe
    if (!rowData.availableInvestissements) {
      return <option value="">Chargement des investissements...</option>;
    }

    // Vérifier si data est un tableau
    const investissements = rowData.availableInvestissements.data;
    if (
      !investissements ||
      !Array.isArray(investissements) ||
      investissements.length === 0
    ) {
      return <option value="">Aucun investissement disponible</option>;
    }

    // Mapper sur le tableau d'investissements de manière sécurisée
    return (
      <>
        <option key="" value=""></option>
        {investissements.map((investissement) => (
          <option
            key={investissement.value || `inv-${Math.random()}`}
            value={investissement.value || ""}
          >
            {investissement.label || "Investissement sans nom"}
          </option>
        ))}
      </>
    );
  };

  //Pme
  const [selectedPme, setSelectedPme] = useState("");
  const [pmessData, setPmesData] = useState({ data: [] });
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/projets/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setPmesData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      <option key="" value=""></option>,
      ...pmessData.data.map((dataItem) => (
        <option key={dataItem.value} value={dataItem.value}>
          {dataItem.label}
        </option>
      )),
    ];
  };

  /*************************   END ANNEE *******************************/
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/projets/show_fields?pme_id=${id}&natures_investissement_id=${
          selectedSecteurActivite?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   Modele *******************************/
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };

  /*************************   END Modele  *******************************/
  /******************************* HMF Tranches *******************************************/
  const [formTranches, setFormTranches] = useState({});

  const onAddFormTranches = () => {
    const modifiedTranches = [...formTranches];
    modifiedTranches.push({
      index: modifiedTranches.length + 1,
      id: null,
      numero: null,
      nombre_actions: null,
      valeur_action: null,
      date_limite_resa: null,
      date_augmentation: null,
      finalisee: null,
    });
    setFormTranches(modifiedTranches);
  };

  const onDeleteFormTranches = (id) => {
    var modifiedTranches = [...formTranches];
    modifiedTranches = modifiedTranches.filter((x) => x["index"] !== id);
    setFormTranches(modifiedTranches);
  };
  const handleInputChange = (index, field, value) => {
    const modifiedTranches = formTranches.map((tanche) => {
      if (tanche.index === index) {
        return {
          ...tanche,
          [field]: value,
        };
      }
      return tanche;
    });

    setFormTranches(modifiedTranches);
  };
  /******************************* END HMF Tranches *******************************************/
  /******************************* HMF DonneesComptable *******************************************/
  const [formDonneesComptable, setFormDonneesComptable] = useState({});

  const onAddFormDonneesComptable = () => {
    const modifiedDonneesComptable = [...formDonneesComptable];
    modifiedDonneesComptable.push({
      index: modifiedDonneesComptable.length + 1,
      id: null,
      annee_id: null,
      montant: null,
    });
    setFormDonneesComptable(modifiedDonneesComptable);
  };

  const onDeleteFormDonneesComptable = (id) => {
    var modifiedDonneesComptable = [...formDonneesComptable];
    modifiedDonneesComptable = modifiedDonneesComptable.filter(
      (x) => x["index"] !== id
    );
    setFormDonneesComptable(modifiedDonneesComptable);
  };
  const handleInputComptableChange = (index, field, value) => {
    const modifiedDonneesComptable = formDonneesComptable.map(
      (donnesComptable) => {
        if (donnesComptable.index === index) {
          return {
            ...donnesComptable,
            [field]: value,
          };
        }
        return donnesComptable;
      }
    );

    setFormDonneesComptable(modifiedDonneesComptable);
  };
  /******************************* END HMF DonneesComptable *******************************************/
  /******************************* HMF Prestation *******************************************/
  const [formPrestation, setFormPrestation] = useState({});

  const onAddFormPrestation = () => {
    const modifiedPrestation = [...formPrestation];
    modifiedPrestation.push({
      index: modifiedPrestation.length + 1,
      id: null,
      partenaire_id: null,
      montant: null,
    });
    setFormPrestation(modifiedPrestation);
  };

  const onDeleteFormPrestation = (id) => {
    var modifiedPrestation = [...formPrestation];
    modifiedPrestation = modifiedPrestation.filter((x) => x["index"] !== id);
    setFormPrestation(modifiedPrestation);
  };
  const handleInputPrestationChange = (index, field, value) => {
    const modifiedPrestation = formPrestation.map((donnesPrestation) => {
      if (donnesPrestation.index === index) {
        return {
          ...donnesPrestation,
          [field]: value,
        };
      }
      return donnesPrestation;
    });

    setFormPrestation(modifiedPrestation);
  };
  /******************************* END HMF Prestation *******************************************/
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [selectedDesignationCourte, setSelectedDesignationCourte] =
    useState("");
  const [selectedExploitant, setSelectedExploitant] = useState("");
  const [selectedValeur, setSelectedValeur] = useState("");
  const [selectedNombreAct, setSelectedNombreAct] = useState("");
  const [selectedCapitalSoc, setSelectedCapitalSoc] = useState("");
  const [selectedNcadastre, setSelectedNcadastre] = useState("");
  const [selectedContenance, setSelectedContenance] = useState("");
  const [selectedContenance2, setSelectedContenance2] = useState("");
  const [selectedNature, setSelectedNature] = useState("");
  const [selectedNature2, setSelectedNature2] = useState("");
  const [selectedLieudit, setSelectedLieudit] = useState("");
  const [selectedAdresse, setSelectedAdresse] = useState("");
  const [selectedCodePostal, setSelectedCodePostal] = useState("");
  const [selectedCommune, setSelectedCommune] = useState("");
  const [selectedSocieteComptable, setSelectedSocieteComptable] = useState("");
  const [selectedNomComptable, setSelectedNomComptable] = useState("");
  const [selectedEmailComptable, setSelectedEmailComptable] = useState("");
  const [selectedMontant, setSelectedMontant] = useState("");
  const [selectedMontant2, setSelectedMontant2] = useState("");
  const [selectedPrixUnitaire, setSelectedPrixUnitaire] = useState("");

  const [selectedPrixUnitaire2, setSelectedPrixUnitaire2] = useState("");

  const [selectedChamps5, setSelectedChamps5] = useState("");
  const [selectedChamps6, setSelectedChamps6] = useState("");

  const handleContenanceChange = (e) => {
    setSelectedContenance(e.target.value);
  };
  const handleContenance2Change = (e) => {
    setSelectedContenance2(e.target.value);
  };
  const handleNatureChange = (e) => {
    setSelectedNature(e.target.value);
  };
  const handleNature2Change = (e) => {
    setSelectedNature2(e.target.value);
  };
  const handleLieuditChange = (e) => {
    setSelectedLieudit(e.target.value);
  };
  const handleAdresseChange = (e) => {
    setSelectedAdresse(e.target.value);
  };
  const handleCodePostalChange = (e) => {
    setSelectedCodePostal(e.target.value);
  };
  const handleCommuneChange = (e) => {
    setSelectedCommune(e.target.value);
  };
  const handleSocieteComptableChange = (e) => {
    setSelectedSocieteComptable(e.target.value);
  };
  const handleNomComptableChange = (e) => {
    setSelectedNomComptable(e.target.value);
  };
  const handleEmailComptableChange = (e) => {
    setSelectedEmailComptable(e.target.value);
  };
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };
  const handleMontant2Change = (e) => {
    setSelectedMontant2(e.target.value);
  };
  const handlePrixUnitaireChange = (e) => {
    setSelectedPrixUnitaire(e.target.value);
  };
  const handlePrixUnitaire2Change = (e) => {
    setSelectedPrixUnitaire2(e.target.value);
  };
  const handleDesignationChange = (e) => {
    setSelectedDesignation(e.target.value);
  };

  const handleDesignationCourteChange = (e) => {
    setSelectedDesignationCourte(e.target.value);
  };
  const handleExploitantChange = (e) => {
    setSelectedExploitant(e);
  };

  const handleValeurChange = (e) => {
    setSelectedValeur(e.target.value);
    setSelectedCapitalSoc(
      parseFloat(e.target.value) * parseFloat(selectedNombreAct)
    );
    document.getElementById("capital_social").value =
      parseFloat(e.target.value) * parseFloat(selectedNombreAct);
  };
  const handleNombreActChange = (e) => {
    setSelectedNombreAct(e.target.value);
  };
  const handleNcadastreChange = (e) => {
    setSelectedNcadastre(e.target.value);
  };

  const handleCapitalSocChange = (e) => {
    setSelectedCapitalSoc(e.target.value);
  };

  const handleChamps5Change = (e) => {
    setSelectedChamps5(e.target.value);
  };

  const handleChamps6Change = (e) => {
    setSelectedChamps6(e.target.value);
  };

  /*************************   END date d'engagement   *******************************/
  /*************************   Complément  *******************************/
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedFichier(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  /************************* END Complément   *******************************/

  /******************************* Date de début *******************************************/
  const [selectedDateDeCrea, setSelectedDateDeCrea] = useState("");

  /******************************* END date de début *******************************************/
  /******************************* date de fin *******************************************/
  const [selectedDateImmatricul, setSelectedDateImmatricul] = useState("");
  /******************************* Valide *******************************************/
  const [selectedValide, setSelectedValide] = useState("");
  const handleValideChange = (e) => {
    setSelectedValide(e);
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  /******************************* END Valide *******************************************/
  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };

  /******************************* END Mode de règlement *******************************************/
  /******************************* RCS *******************************************/
  const [selectedRcs, setSelectedRcs] = useState("");
  const handleRcsChange = (e) => {
    setSelectedRcs(e.target.value);
  };
  /******************************* END RCS *******************************************/
  /******************************* NomProjet *******************************************/
  const [selectedNomProjet, setSelectedNomProjet] = useState("");
  const handleNomProjetChange = (e) => {
    setSelectedNomProjet(e.target.value);
  };
  /******************************* END NomProjet *******************************************/
  /******************************* Objet Social *******************************************/
  const [selectedObjetSocial, setSelectedObjetSocial] = useState("");
  const handleObjetSocialChange = (e) => {
    setSelectedObjetSocial(e.target.value);
  };
  /******************************* END Objet Social *******************************************/
  // From Investissement
  const keyTheortical = {
    header: ["Year", "Flow type", "Tranche number", "Pourcentage"],
    data: [],
  };
  const [formInvestissement, setFormInvestissement] = useState([]);
  console.log(formInvestissement);
  //   console.log(formInvestissement);
  const onAddFormInvestissement = () => {
    const modifiedInvestissement = [...formInvestissement];
    // console.log(modifiedInvestissement);
    modifiedInvestissement.push({
      index: modifiedInvestissement.length + 1,
      id: null,
      pme_id: null,
      montant: null,
      pourcentage: null,
      montant_2: null,
      pourcentage_2: null,
      investissement_id: null,
      availableInvestissements: [], // Nouveau champ pour stocker les investissements disponibles
    });

    setFormInvestissement(modifiedInvestissement);
  };
  const onDeleteFormInvestissement = (id) => {
    setFormInvestissement((prevState) =>
      prevState.map((item) =>
        item.index === id ? { ...item, _destroy: 1 } : item
      )
    );
  };
  const [renderTrigger, setRenderTrigger] = useState(0);
  const handleInputInvestissementChange = (index, field, value) => {
    const modifiedInvestissement = formInvestissement.map(
      (donnesInvestissement) => {
        if (donnesInvestissement.index === index) {
          // Création de l'objet mis à jour
          const updatedData = {
            ...donnesInvestissement,
            [field]: value,
          };

          // Si le champ modifié est "montant", on met à jour automatiquement le pourcentage
          if (field === "montant") {
            // Calculer le nouveau pourcentage
            const newPourcentage = calculerPourcentage(value);

            // Retourner un nouvel objet avec montant et pourcentage mis à jour
            return {
              ...donnesInvestissement,
              [field]: value,
              pourcentage: newPourcentage,
            };
          }
          if (field === "montant_2") {
            const newPourcentage2 = calculerPourcentage2(value);
            return {
              ...donnesInvestissement,
              [field]: value,
              pourcentage_2: newPourcentage2,
            };
          }
          if (field === "pme_id") {
            // Déclencher l'appel API pour récupérer les investissements pour ce PME
            if (value) {
              getInvestissementByPmeId(value, index);
            }

            return {
              ...donnesInvestissement,
              [field]: value,
              investissement_id: null, // Réinitialiser l'investissement sélectionné
            };
          }
          return updatedData;
        }
        return donnesInvestissement;
      }
    );
    // Forcer un re-rendu
    setRenderTrigger((prev) => prev + 1);
    setFormInvestissement(modifiedInvestissement);
  };

  // Fonction de calcul du pourcentage basée sur le montant
  // À adapter selon votre logique métier
  const calculerPourcentage = (montant) => {
    if (montant === null || montant === "") return null;
    if (
      selectedMontant == "" ||
      selectedMontant == null ||
      selectedMontant2 == "" ||
      selectedMontant2 == null
    )
      return 0;
    return Number((montant / selectedMontant) * 100).toFixed(2);
  };
  const calculerPourcentage2 = (montant) => {
    if (montant === null || montant === "") return null;
    if (selectedMontant2 == "" || selectedMontant2 == null) return 0;
    return Number((montant / selectedMontant2) * 100).toFixed(2);
  };
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);

    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`https://www.fluxod.com/${api}/projets/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          designation: selectedDesignation,
          designation_courte: selectedDesignationCourte,
          n_cadastre: selectedNcadastre,
          contenance: selectedContenance,
          contenance_2: selectedContenance2,
          nature: selectedNature,
          nature_2: selectedNature2,
          lieudit: selectedLieudit,
          adresse: selectedAdresse,
          code_postal: selectedCodePostal,
          commune: selectedCommune,
          comptable_societe: selectedSocieteComptable,
          comptable_nom: selectedNomComptable,
          comptable_email: selectedEmailComptable,
          montant: selectedMontant,
          prix_unitaire: selectedPrixUnitaire,
          montant2: selectedMontant2,
          prix_unitaire_2: selectedPrixUnitaire2,
          partenaire2_id: selectedExploitant?.value || "",
          classe_immobilisation_id: selectedClasseImmo?.value || "",
          secteur_activite_id: selectedSecteurActivite?.value || "",
          codes_investissement_id: selectedCodesInvestissement?.value || "",
          partenaire_id: selectedDirectionProduit?.value || "",
          statut_projet_id: selectedStatutProjet?.value || "",
          projet_details_attributes: formInvestissement?.map((obj) => {
            const { index, availableInvestissements, ...rest } = obj;
            return rest;
          }),
        }),
      });
      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.projet_validation) {
          const errors = responseData?.projet_validation;
          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  /******************************* END Validation *******************************************/

  useEffect(() => {
    if (!loading) {
      getInvestissementByPmeId("");
      getDirectionProduit();
      getSecteurActivite();
      getCodesInvestissement();
      getPme();
      getClasseImmo();
      getStatutProjet();
      getExploitantData();
      // getPartenaire();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      // getShow();
    }
  }, [loading, selectedSecteurActivite]);
  const key = {
    sil: "TEST",
    detail_projet: {
      Identication: {
        Designation: "Projet XX\nd\nd",
        "Designation courte": "Projet 1",
        "Classe d'immobilisation": {
          label: "PISTES AGRICOLES, CANNEAUX D'IRRIGATION, PATURAGES",
          value: 1,
        },
        "Code secteur": {
          label: "HM / Hôtellerie - mobilier",
          value: 1,
        },
        "Direction produit": {
          label: "SARL VILLAGE VACANCES",
          value: 1,
        },
        "Statut du projet": {
          label: "En attente",
          value: 1,
        },
        Exploitant: {
          label: "SARL VILLAGE VACANCES",
          value: 1,
        },
        "N° de cadastre": "1234567890",
        Lieudit: "Paris",
        Adresse: "99 rue de la paix",
        "Code postal": "75000",
        Commune: "Paris",
        "Société comptable": "SARL VILLAGE VACANCES",
        "Nom comptable": "SARL VILLAGE VACANCES",
        "Email comptable": "SARL VILLAGE VACANCES",
      },
      "Lot 1": {
        Contenance: "12345 ML",
        Nature: "Canaux d'irrigation",
        Montant: 1234570000,
        "Prix unitaire": 1234570000,
      },
      "Lot 2": {
        "Contenance 2": "12345 ML",
        "Nature 2": "Canaux d'irrigation",
        "Montant 2": 1234570000,
        "Prix unitaire 2": 1234570000,
      },
      Investissements: {
        Investissements: {
          data: [],
          header: [
            "PME",
            "Montant",
            "Pourcentage",
            "Montant 2",
            "Pourcentage 2",
            "Investissement",
          ],
        },
      },
    },
    mandatory_fields: [
      "classe_immobilisation_id",
      "partenaire_id",
      "statut_projet_id",
    ],
  };
  const sections = [
    {
      key: "Lot 1",
      title: "Lot 1",
    },
    {
      key: "Lot 2",
      title: "Lot 2",
    },
  ];
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Projets | New";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Projets
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/projets/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Projets
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          "Nouveau"
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    <CardTitle>Identification</CardTitle>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {key?.detail_projet?.Identication ? (
                                  <Card className="mb-4">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingLeft: "10px" }}
                                    >
                                      {" "}
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        key?.detail_projet?.Identication
                                      )
                                        .slice(
                                          0,
                                          Math.ceil(
                                            Object.keys(
                                              key?.detail_projet?.Identication
                                            ).length / 2
                                          )
                                        )
                                        .map(([key, value], index) => (
                                          <Row className="mb-2" key={index}>
                                            {key ===
                                            "Classe d'immobilisation" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedClasseImmo?.label ==
                                                      null
                                                        ? null
                                                        : selectedClasseImmo
                                                    }
                                                    onChange={
                                                      handleClasseImmoChange
                                                    }
                                                    options={renderClasseImmoOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedClasseImmo ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedClasseImmo ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Classe d'immobilisation ne
                                                      peut pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Secteur d'activité" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedSecteurActivite?.label ==
                                                      null
                                                        ? null
                                                        : selectedSecteurActivite
                                                    }
                                                    onChange={
                                                      handleSecteurActiviteChange
                                                    }
                                                    options={renderSecteurActiviteOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Code secteur" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedCodesInvestissement?.label ==
                                                      null
                                                        ? null
                                                        : selectedCodesInvestissement
                                                    }
                                                    onChange={
                                                      handleCodesInvestissementChange
                                                    }
                                                    options={renderCodesInvestissementOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Direction produit" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedDirectionProduit?.label ==
                                                      null
                                                        ? null
                                                        : selectedDirectionProduit
                                                    }
                                                    onChange={
                                                      handleDirectionProduitChange
                                                    }
                                                    options={renderDirectionProduitOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Statut du projet" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedStatutProjet?.label ==
                                                      null
                                                        ? null
                                                        : selectedStatutProjet
                                                    }
                                                    onChange={
                                                      handleStatutProjetChange
                                                    }
                                                    options={renderStatutProjetOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedStatutProjet ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedStatutProjet ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Statut du projet ne peut
                                                      pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Exploitant" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedExploitant?.label ==
                                                      null
                                                        ? null
                                                        : selectedExploitant
                                                    }
                                                    onChange={
                                                      handleExploitantChange
                                                    }
                                                    options={renderExploitantOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedExploitant ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedExploitant ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Statut du projet ne peut
                                                      pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Nom du projet" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNomProjet
                                                    }
                                                    onChange={
                                                      handleNomProjetChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "N° de cadastre" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNcadastre
                                                    }
                                                    onChange={
                                                      handleNcadastreChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Designation" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key}* :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <textarea
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      selectedDesignation
                                                    }
                                                    onChange={
                                                      handleDesignationChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Designation courte" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedDesignationCourte
                                                    }
                                                    onChange={
                                                      handleDesignationCourteChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Contenance" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedContenance
                                                    }
                                                    onChange={
                                                      handleContenanceChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Contenance 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedContenance2
                                                    }
                                                    onChange={
                                                      handleContenance2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nature" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNature
                                                    }
                                                    onChange={
                                                      handleNatureChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nature 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNature2
                                                    }
                                                    onChange={
                                                      handleNature2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Lieudit" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedLieudit
                                                    }
                                                    onChange={
                                                      handleLieuditChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Adresse" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedAdresse
                                                    }
                                                    onChange={
                                                      handleAdresseChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Code postal" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedCodePostal
                                                    }
                                                    onChange={
                                                      handleCodePostalChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Commune" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedCommune
                                                    }
                                                    onChange={
                                                      handleCommuneChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Société comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedSocieteComptable
                                                    }
                                                    onChange={
                                                      handleSocieteComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nom comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNomComptable
                                                    }
                                                    onChange={
                                                      handleNomComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Email comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedEmailComptable
                                                    }
                                                    onChange={
                                                      handleEmailComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Société comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedSocieteComptable
                                                    }
                                                    onChange={
                                                      handleSocieteComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nom comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNomComptable
                                                    }
                                                    onChange={
                                                      handleNomComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Email comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedEmailComptable
                                                    }
                                                    onChange={
                                                      handleEmailComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Montant" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedMontant
                                                    }
                                                    onChange={
                                                      handleMontantChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Montant 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedMontant2
                                                    }
                                                    onChange={
                                                      handleMontant2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Prix unitaire" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedPrixUnitaire
                                                    }
                                                    onChange={
                                                      handlePrixUnitaireChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Prix unitaire 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedPrixUnitaire2
                                                    }
                                                    onChange={
                                                      handlePrixUnitaire2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : null}
                                          </Row>
                                        ))}
                                    </CardBody>
                                  </Card>
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {key?.detail_projet?.Identication ? (
                                  <Card className="mb-4">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingLeft: "10px" }}
                                    >
                                      {" "}
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        key?.detail_projet?.Identication
                                      )
                                        .slice(
                                          Math.ceil(
                                            Object.keys(
                                              key?.detail_projet?.Identication
                                            ).length / 2
                                          )
                                        )
                                        .map(([key, value], index) => (
                                          <Row className="mb-2" key={index}>
                                            {key ===
                                            "Classe d'immobilisation" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedClasseImmo?.label ==
                                                      null
                                                        ? null
                                                        : selectedClasseImmo
                                                    }
                                                    onChange={
                                                      handleClasseImmoChange
                                                    }
                                                    options={renderClasseImmoOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedClasseImmo ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedClasseImmo ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Classe d'immobilisation ne
                                                      peut pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Secteur d'activité" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedSecteurActivite?.label ==
                                                      null
                                                        ? null
                                                        : selectedSecteurActivite
                                                    }
                                                    onChange={
                                                      handleSecteurActiviteChange
                                                    }
                                                    options={renderSecteurActiviteOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Direction produit" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedDirectionProduit?.label ==
                                                      null
                                                        ? null
                                                        : selectedDirectionProduit
                                                    }
                                                    onChange={
                                                      handleDirectionProduitChange
                                                    }
                                                    options={renderDirectionProduitOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Statut du projet" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedStatutProjet?.label ==
                                                      null
                                                        ? null
                                                        : selectedStatutProjet
                                                    }
                                                    onChange={
                                                      handleStatutProjetChange
                                                    }
                                                    options={renderStatutProjetOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedStatutProjet ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedStatutProjet ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Statut du projet ne peut
                                                      pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Exploitant" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedExploitant?.label ==
                                                      null
                                                        ? null
                                                        : selectedExploitant
                                                    }
                                                    onChange={
                                                      handleExploitantChange
                                                    }
                                                    options={renderExploitantOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedExploitant ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedExploitant ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Statut du projet ne peut
                                                      pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Nom du projet" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNomProjet
                                                    }
                                                    onChange={
                                                      handleNomProjetChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "N° de cadastre" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNcadastre
                                                    }
                                                    onChange={
                                                      handleNcadastreChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Designation" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key}* :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <textarea
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      selectedDesignation
                                                    }
                                                    onChange={
                                                      handleDesignationChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Designation courte" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedDesignationCourte
                                                    }
                                                    onChange={
                                                      handleDesignationCourteChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Contenance" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedContenance
                                                    }
                                                    onChange={
                                                      handleContenanceChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Contenance 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedContenance2
                                                    }
                                                    onChange={
                                                      handleContenance2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nature" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNature
                                                    }
                                                    onChange={
                                                      handleNatureChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nature 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNature2
                                                    }
                                                    onChange={
                                                      handleNature2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Lieudit" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedLieudit
                                                    }
                                                    onChange={
                                                      handleLieuditChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Adresse" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedAdresse
                                                    }
                                                    onChange={
                                                      handleAdresseChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Code postal" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedCodePostal
                                                    }
                                                    onChange={
                                                      handleCodePostalChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Commune" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedCommune
                                                    }
                                                    onChange={
                                                      handleCommuneChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Société comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedSocieteComptable
                                                    }
                                                    onChange={
                                                      handleSocieteComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nom comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNomComptable
                                                    }
                                                    onChange={
                                                      handleNomComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Email comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedEmailComptable
                                                    }
                                                    onChange={
                                                      handleEmailComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Montant" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedMontant
                                                    }
                                                    onChange={
                                                      handleMontantChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Montant 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedMontant2
                                                    }
                                                    onChange={
                                                      handleMontant2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Prix unitaire" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedPrixUnitaire
                                                    }
                                                    onChange={
                                                      handlePrixUnitaireChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Prix unitaire 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedPrixUnitaire2
                                                    }
                                                    onChange={
                                                      handlePrixUnitaire2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : null}
                                          </Row>
                                        ))}
                                    </CardBody>
                                  </Card>
                                ) : null}
                              </Col>
                              {sections.map((section, sectionIndex) => (
                                <Col sm="6">
                                  {key?.detail_projet?.[section.key] ? (
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        {section.title}
                                      </CardTitle>
                                      <CardBody>
                                        {Object.entries(
                                          key?.detail_projet?.[section.key]
                                        ).map(([key, value], index) => (
                                          <Row className="mb-2" key={index}>
                                            {key ===
                                            "Classe d'immobilisation" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedClasseImmo?.label ==
                                                      null
                                                        ? null
                                                        : selectedClasseImmo
                                                    }
                                                    onChange={
                                                      handleClasseImmoChange
                                                    }
                                                    options={renderClasseImmoOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedClasseImmo ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedClasseImmo ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Classe d'immobilisation ne
                                                      peut pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Secteur d'activité" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedSecteurActivite?.label ==
                                                      null
                                                        ? null
                                                        : selectedSecteurActivite
                                                    }
                                                    onChange={
                                                      handleSecteurActiviteChange
                                                    }
                                                    options={renderSecteurActiviteOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Direction produit" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedDirectionProduit?.label ==
                                                      null
                                                        ? null
                                                        : selectedDirectionProduit
                                                    }
                                                    onChange={
                                                      handleDirectionProduitChange
                                                    }
                                                    options={renderDirectionProduitOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Statut du projet" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedStatutProjet?.label ==
                                                      null
                                                        ? null
                                                        : selectedStatutProjet
                                                    }
                                                    onChange={
                                                      handleStatutProjetChange
                                                    }
                                                    options={renderStatutProjetOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedStatutProjet ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedStatutProjet ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Statut du projet ne peut
                                                      pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Exploitant" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedExploitant?.label ==
                                                      null
                                                        ? null
                                                        : selectedExploitant
                                                    }
                                                    onChange={
                                                      handleExploitantChange
                                                    }
                                                    options={renderExploitantOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(
                                                      selectedExploitant ===
                                                        null
                                                    )}
                                                  />
                                                  {selectedExploitant ===
                                                  null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Statut du projet ne peut
                                                      pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key === "Nom du projet" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNomProjet
                                                    }
                                                    onChange={
                                                      handleNomProjetChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "N° de cadastre" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNcadastre
                                                    }
                                                    onChange={
                                                      handleNcadastreChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Designation" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key}* :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <textarea
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      selectedDesignation
                                                    }
                                                    onChange={
                                                      handleDesignationChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Designation courte" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedDesignationCourte
                                                    }
                                                    onChange={
                                                      handleDesignationCourteChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Contenance" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedContenance
                                                    }
                                                    onChange={
                                                      handleContenanceChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Contenance 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedContenance2
                                                    }
                                                    onChange={
                                                      handleContenance2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nature" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNature
                                                    }
                                                    onChange={
                                                      handleNatureChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nature 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNature2
                                                    }
                                                    onChange={
                                                      handleNature2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Lieudit" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedLieudit
                                                    }
                                                    onChange={
                                                      handleLieuditChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Adresse" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedAdresse
                                                    }
                                                    onChange={
                                                      handleAdresseChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Code postal" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedCodePostal
                                                    }
                                                    onChange={
                                                      handleCodePostalChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Commune" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedCommune
                                                    }
                                                    onChange={
                                                      handleCommuneChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Société comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedSocieteComptable
                                                    }
                                                    onChange={
                                                      handleSocieteComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Nom comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedNomComptable
                                                    }
                                                    onChange={
                                                      handleNomComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Email comptable" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedEmailComptable
                                                    }
                                                    onChange={
                                                      handleEmailComptableChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Montant" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedMontant
                                                    }
                                                    onChange={
                                                      handleMontantChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Montant 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedMontant2
                                                    }
                                                    onChange={
                                                      handleMontant2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Prix unitaire" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedPrixUnitaire
                                                    }
                                                    onChange={
                                                      handlePrixUnitaireChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key === "Prix unitaire 2" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    defaultValue={
                                                      selectedPrixUnitaire2
                                                    }
                                                    onChange={
                                                      handlePrixUnitaire2Change
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : null}
                                          </Row>
                                        ))}
                                      </CardBody>
                                    </Card>
                                  ) : null}
                                </Col>
                              ))}
                              <Col sm="12">
                                {key?.detail_projet?.["Investissements"] ? (
                                  <>
                                    <Card className="mb-4">
                                      <CardTitle tag="h5">
                                        Investissements{" "}
                                      </CardTitle>
                                      <CardBody>
                                        <Col sm="12">
                                          <div className="table-responsive">
                                            <table
                                              className="table table-bordered rounded-3 overflow-hidden"
                                              style={{
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  {key?.detail_projet?.[
                                                    "Investissements"
                                                  ]?.[
                                                    "Investissements"
                                                  ].header.map(
                                                    (columnName, index) => (
                                                      <th
                                                        className=""
                                                        style={tableaustyles}
                                                        key={index}
                                                      >
                                                        {columnName}
                                                      </th>
                                                    )
                                                  )}
                                                  <th
                                                    className=""
                                                    style={{
                                                      background:
                                                        "rgb(80, 165, 241)",
                                                      color: "white",
                                                      paddingTop: "5px",
                                                      paddingBottom: "5px",
                                                      width: "1%",
                                                    }}
                                                    key="Del"
                                                  ></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {formInvestissement?.map(
                                                  (rowData) => (
                                                    <tr key={rowData.index}>
                                                      {Object.entries(
                                                        rowData
                                                      ).map(([key, value]) =>
                                                        key !== "id" &&
                                                        key !== "index" &&
                                                        key !==
                                                          "availableInvestissements" ? (
                                                          <td key={key}>
                                                            {key ===
                                                            "investissement_id" ? (
                                                              <select
                                                                value={value}
                                                                name={key}
                                                                className="form-control form-control-sm"
                                                                onChange={(e) =>
                                                                  handleInputInvestissementChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              >
                                                                {renderInvestissementOptions(
                                                                  rowData
                                                                )}
                                                              </select>
                                                            ) : key ===
                                                              "pme_id" ? (
                                                              <select
                                                                value={value}
                                                                name={key}
                                                                className="form-control form-control-sm"
                                                                onChange={(e) =>
                                                                  handleInputInvestissementChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              >
                                                                {renderPmeOptions()}
                                                              </select>
                                                            ) : key ===
                                                              "montant" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                defaultValue={
                                                                  value
                                                                }
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputInvestissementChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : key ===
                                                              "pourcentage" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                value={value}
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputInvestissementChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : key ===
                                                              "montant_2" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                defaultValue={
                                                                  value
                                                                }
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputInvestissementChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : key ===
                                                              "pourcentage_2" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                value={value}
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputInvestissementChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : key ===
                                                              "availableInvestissements" ? null : (
                                                              <span>
                                                                {value}
                                                              </span>
                                                            )}
                                                          </td>
                                                        ) : (
                                                          <td
                                                            className="d-none"
                                                            key={key}
                                                          >
                                                            <input
                                                              type="hidden"
                                                              value={value}
                                                            />
                                                          </td>
                                                        )
                                                      )}
                                                      <td>
                                                        <i
                                                          className="bx bx-trash"
                                                          style={{
                                                            fontSize: "20px",
                                                            paddingTop: "5px",
                                                            textAlign: "center",
                                                            verticalAlign:
                                                              "middle",
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() =>
                                                            onDeleteFormInvestissement(
                                                              rowData.index
                                                            )
                                                          }
                                                        ></i>
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                                <tr>
                                                  <td colSpan="9">
                                                    <input
                                                      type="button"
                                                      style={tableaustyles}
                                                      className="btn btn-info mt-3 mt-lg-0"
                                                      value="Ajouter"
                                                      onClick={
                                                        onAddFormInvestissement
                                                      }
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </Col>
                                      </CardBody>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewProjects;
